import React from "react";

//@material-ui
import { makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  infoAlert: {
    fontSize: "1em",
    marginBlockStart: "1rem",
    paddingBlockStart: "0.5rem",
    width: "50%",
    marginInline: "auto",
    "& .MuiAlert-icon": {
      fontSize: 30,
    },
    "& .MuiAlert-message": {
      color: "#000",
      "& li": {
        paddingBlockEnd: "0.5rem",
      },
    },
  },
}));

const Page404 = ({ chosenGame }) => {
  const classes = useStyles();
  const titleCase = (str) =>
    `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;
  return (
    <div className="game_view--not_found">
      <Alert severity="info" className={classes.infoAlert}>
        Kunde inte hitta spel{" "}
        <strong className="chosen-game__404">{titleCase(chosenGame)}</strong>.{" "}
        <br />
        Något utav följande kan ha hänt:
        <ul>
          <li>
            Spelet finns inte, eller är felstavat. <br />
            Prova med att{" "}
            <a className="link" href="/gissa-partiet/alla-spel">
              kolla i listan om spelet finns.
            </a>
          </li>
          <li>Spelet finns, men inga politiker är ännu tillagda.</li>
        </ul>
      </Alert>
    </div>
  );
};

export default Page404;
